export enum ApplicationType {
  DC = 'Direct Credit',
  ICC = 'Credit Conversion',
  PRA = 'PRA',
}
